import { z } from 'zod'

export const supportedLocaleSchema = z.enum(['de', 'en'])
export const supportedLocaleOptions = supportedLocaleSchema.options
export type SupportedLocale = z.infer<typeof supportedLocaleSchema>
